import { getDataset, getDatasets } from '@/api/dataviewer';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

const initialValues = {
  datasets: null,
  isLoadingDatasets: false,
  selectedDataset: null,
  isLoadingDataset: false,
  searchQuery: '',
  filters: {},
  viewMode: 'table',
};

const useDataviewerStore = create()(immer(() => initialValues));
const { setState: set } = useDataviewerStore;

export const dataviewerActions = {
  loadDatasets: async () => {
    set(state => {
      state.isLoadingDatasets = true;
    });
    try {
      const response = await getDatasets();
      set(state => {
        state.datasets = response.data;
        state.isLoadingDatasets = false;
      });
    } catch (error) {
      set(state => {
        state.isLoadingDatasets = false;
      });
      throw error;
    }
  },

  selectDataset: async (category, slug) => {
    set(state => {
      state.isLoadingDataset = true;
      state.selectedDataset = null;
      state.filters = {};
    });
    try {
      const response = await getDataset(category, slug);
      set(state => {
        state.selectedDataset = response.data;
        state.isLoadingDataset = false;
      });
    } catch (error) {
      set(state => {
        state.isLoadingDataset = false;
      });
      throw error;
    }
  },

  // value is an array of selected options for key; empty array removes the filter
  setFilter: (key, values) => {
    set(state => {
      if (!values || values.length === 0) {
        delete state.filters[key];
      } else {
        state.filters[key] = values;
      }
    });
  },

  clearFilters: () =>
    set(state => {
      state.filters = {};
    }),

  setSearchQuery: query =>
    set(state => {
      state.searchQuery = query;
    }),

  setViewMode: mode =>
    set(state => {
      state.viewMode = mode;
    }),

  reset: () => set(initialValues),
};

export default useDataviewerStore;
